<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row">
				<div class="col-md-8">
					<a-radio-group :value="filters.status" @change="handleStatusChange" style="padding: 10px 20px; background-color: #dedede">
						<a-radio-button value="0"> Solicitudes </a-radio-button>
						<a-radio-button value="1"> Cotizadas </a-radio-button>
						<a-radio-button value="5"> Enviadas </a-radio-button>
						<a-radio-button value="2"> Autorizadas </a-radio-button>
						<a-radio-button value="3"> En sucursal </a-radio-button>
						<a-radio-button value="4"> Entregado </a-radio-button>
					</a-radio-group>
				</div>
				<div class="col-md-4 text-right">
					<a-button class="btn btn-info" icon="plus" @click="onAddRecord">Nueva cotización</a-button>
					<a-button class="btn btn-success ml7" icon="reload" @click="initModule" />
				</div>
			</div>
			<div class="row pt10">
				<div class="col-md-3">
					<b>Ubicación</b>
					<a-select v-model="branch_office_id" :style="{ width: '100%' }" @change="initModule(false)">
						<a-select-option value=""> Todas </a-select-option>
						<a-select-option v-for="(element, key) in branchOfficesList" :key="key" :value="element.id"> {{ element.branch_office_name }} </a-select-option>
					</a-select>
				</div>
				<div class="col-md-3" style="margin-top: 20px">
					<a-input-search v-model="odsText" placeholder="Buscar por No. ODS" @search="initModule(false)" @pressEnter="initModule(false)" allow-clear />
				</div>
				<div class="col-md-6" style="margin-top: 20px">
					<a-input-search v-model="searchText" placeholder="Búsqueda por SKU, Marca, Modelo o Producto" @search="initModule(false)" @pressEnter="initModule(false)" allow-clear />
				</div>
			</div>
			<div class="row pt10">
				<div class="col-md-12">
					<a-table :columns="columns" :dataSource="impressmentListFiltered" :pagination="pagination" :loading="spinnerLoader" rowKey="id" bordered @change="initModule">
						<div slot="id" slot-scope="record">
							{{ record.id }}
							<div>
								<b>{{ record?.branch_office_name ?? '' }}</b>
							</div>
							<div style="padding-top: 5px" v-if="searchText || odsText">
								<span style="font-size: 11px">Estatus:</span><br />
								<a-tag style="margin-right: 0; margin-top: 2px">{{ getStatusBadge(record.status).text }}</a-tag>
							</div>
						</div>
						<div slot="fullName" slot-scope="record" class="text-left">
							<b>{{ record.fullName }}</b>
							<div style="padding-top: 5px">
								<a :href="`https://taller.rls.com.mx/admin/servicios/${record.service_order}`" target="_blank" v-if="record.service_order > 0">
									<a-tag :color="[7, 10, 11].includes(record.serviceOrderStatus) ? 'red' : 'green'" class="pointer">ODS {{ record.service_order }}</a-tag>
								</a>
							</div>
							<div style="padding-top: 5px"><a-tag color="blue" v-if="record.local_required">Requerida en Mostrador</a-tag></div>
							<div>{{ moment(record.created_at).format('DD-MM-YYYY HH:mm') }} hrs.</div>
							<div style="padding-top: 5px" v-if="record.trengo">
								<a :href="record.trengo" target="new"><a-tag color="purple">Link a conversación</a-tag></a>
							</div>
						</div>
						<div slot="description" slot-scope="record" class="text-left">
							<div v-if="record.status > 1 && record.status != 5">
								<div>
									<b>== Autorizado por el cliente ==</b>
									<div v-for="(element, index) in record.impressmentElements.filter((e) => e.confirmed)" :key="`confirmed_${index}`">
										{{ `${element.quantity}` }}<small class="fs10">x</small> {{ element.description }}
									</div>
								</div>
								<div v-if="record.impressmentElements.filter((e) => e.confirmed == false).length">
									<b>== Rechazado ==</b>
									<div v-for="(element, index) in record.impressmentElements.filter((e) => e.confirmed == false)" :key="`rejected_${index}`">
										{{ `${element.quantity}` }}<small class="fs10">x</small> {{ element.description }}
									</div>
								</div>
							</div>
							<div v-else>
								<div v-for="(element, index) in record.impressmentElements" :key="index">
									{{ `${element.quantity}` }}<small class="fs10">x</small> {{ element.description }} || {{ numeral(element.price).format('$0,0.00') }}
									<a-alert message="Producto agotado o no disponible" banner v-if="!element.available" />
								</div>
							</div>
						</div>
						<div slot="amount" slot-scope="record">
							<div v-if="record.status != 0" class="text-right">
								{{ getAmount(record.id) }}
							</div>
							<div v-else>---</div>
						</div>
						<div slot="action" slot-scope="record">
							<div>
								<a-tooltip title="Editar cotización">
									<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="onEditRecord(record.id)" v-if="record.status == 0">
										<a-icon type="edit" />
									</button>
								</a-tooltip>
								<a-tooltip title="Confirmar cotización">
									<button class="btn btn-success ant-btn-sm ant-btn-icon-only ml7" @click="openModal(record.id)" v-if="record.status == 5 && allowOperations(record.impressmentElements)">
										<a-icon type="check" />
									</button>
								</a-tooltip>
							</div>
							<div class="pt5">
								<!-- <button class="btn btn-warning ant-btn-sm ant-btn-icon-only ml7" @click="downloadQuotation(record.id)" v-if="record.status >= 1 && allowOperations(record.impressmentElements)">
									<a-icon type="cloud-download" />
								</button> -->
								<!-- || record.status == 5 -->
								<a-tooltip title="Enviar cotización">
									<button
										class="btn btn-info ant-btn-sm ant-btn-icon-only ml7"
										@click="sendQuotation(record.id)"
										v-if="[1, 5].includes(record.status) && allowOperations(record.impressmentElements) && record.trengo"
									>
										<a-icon type="message" />
									</button>
								</a-tooltip>
								<a-tooltip title="Regresar para editar">
									<button class="btn btn-warning ant-btn-sm ant-btn-icon-only ml7" @click="returnToDraft(record.id)" v-if="[1, 5].includes(record.status)">
										<a-icon type="rollback" />
									</button>
								</a-tooltip>
								<a-tooltip title="Eliminar cotización">
									<button class="btn btn-danger ant-btn-sm ant-btn-icon-only ml7" @click="onDelete(record.id)" v-if="[0, 1, 5].includes(record.status)">
										<a-icon type="close" />
									</button>
								</a-tooltip>
								<a-tooltip title="Completar cotización">
									<button class="btn btn-success ant-btn-sm ant-btn-icon-only ml7" @click="completeQuotation(record.id)" v-if="record.status == 2">
										<a-icon type="check" />
									</button>
								</a-tooltip>
								<a-tooltip title="Entregar cotización">
									<button class="btn btn-success ant-btn-sm ant-btn-icon-only ml7" @click="deliverQuotation(record.id)" v-if="record.status == 3">
										<a-icon type="check" />
									</button>
								</a-tooltip>
								<a-tooltip title="Descargar cotización">
									<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="downloadQuotation(record.id)" v-if="record.status > 0 && allowOperations(record.impressmentElements)">
										<a-icon type="file" />
									</button>
								</a-tooltip>
							</div>
						</div>
					</a-table>
				</div>
			</div>
		</a-spin>
		<a-modal :visible="modalQuotationView" title="Detalle de cotización" :closable="false" width="80%" v-if="modalQuotationView">
			<template slot="footer">
				<a-button key="download" type="primary" icon="download" @click="downloadPDF"> Descargar PDF </a-button>
				<a-button key="back" @click="closeQuotationModal"> Cerrar </a-button>
			</template>
			<div class="col-md-12 pt10 text-center">
				<a-pagination v-if="numPages > 1" v-model="actualPage" :total="numPages" :page-size="1" show-less-items style="margin-bottom: 20px" />
				<pdf v-for="i in numPages" :key="i" :src="quotationSrc" :page="i" style="display: none" v-show="i == actualPage" />
			</div>
		</a-modal>

		<a-modal :visible="modalView" title="Detalle de cotización" :closable="false" width="80%" v-if="actualRecord.impressmentElements">
			<template slot="footer">
				<a-button key="back" @click="closeModal"> Cancelar </a-button>
				<a-button key="submit" class="btn btn-success" @click="onCloseQuotation"> Confirmar </a-button>
			</template>
			<a-table
				:rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
				:footer="null"
				:columns="columnsElements"
				:data-source="getImpressmentElements"
				:pagination="false"
				class="tableImpressmentElements"
			>
				<div slot="index" slot-scope="record">
					{{ record.index }}
				</div>
				<div slot="description" slot-scope="record">
					<div class="text-left">
						{{ record.quantity }}<small class="fs10">x</small> {{ record.description }}
						<div v-if="record.link">
							<span class="pointer" @click="onLinkPress(record.link)"><a-icon type="login" /> Abrir link</span>
						</div>
					</div>
				</div>
				<div slot="price" slot-scope="record" class="text-right">{{ numeral(record.price).format('$0,0.00') }}</div>
				<div slot="importe" slot-scope="record" class="text-right">{{ numeral(numeral(record.quantity).value() * numeral(record.price).value()).format('$0,0.00') }}</div>
				<div slot="delivery_time" slot-scope="record">
					{{ record.delivery_time }}
				</div>
			</a-table>
		</a-modal>
	</div>
</template>

<script>
//
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import _ from 'lodash'
import numeral from 'numeral'
import { branchOffices } from '@/constants'
import utilities from '@/services/utilities'
import pdf from 'vue-pdf'
const dateFormat = 'YYYY-MM-DD'

export default {
	name: 'ImpressmentView',
	components: {
		pdf,
	},
	computed: {
		...mapGetters('impressment', ['spinnerLoader', 'spinnerLoaderLabel', 'impressmentList', 'filters']),
		...mapGetters('serviceOrders', ['serviceOrdersList']),
		...mapGetters('user', ['user']),
		...mapGetters('branchOffices', ['branchOfficesList']),
		userPermition() {
			// zem - 17
			// pozos - 11
			// ismael - 1
			let allowedUserPermition = [1, 17]
			// return !!allowedUserPermition.includes(17)
			return !!allowedUserPermition.includes(this.user.user_id)
		},
		getImpressmentElements() {
			return this.actualRecord.impressmentElements
				.filter((e) => e.available)
				.map((e, index) => {
					return {
						...e,
						index: index + 1,
					}
				})
		},
	},
	data() {
		return {
			branchOffices,
			dateFormat,
			defaultDate: [moment().startOf('month').format(dateFormat), moment(moment().endOf('month')).format(dateFormat)],
			searchText: '',
			odsText: '',
			branch_office_id: '',
			impressmentListFiltered: [],
			modalQuotationView: false,
			quotationSrc: null,
			numPages: undefined,
			actualPage: 1,
			actualPdfBase64: null,
			actualPdfId: null,
			columns: [
				{
					title: 'ID/SUCURSAL',
					scopedSlots: { customRender: 'id' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Solicitante',
					scopedSlots: { customRender: 'fullName' },
					width: '25%',
				},
				{
					title: 'Solicitud',
					scopedSlots: { customRender: 'description' },
					align: 'center',
					width: '40%',
				},
				{
					title: 'Monto',
					scopedSlots: { customRender: 'amount' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'center',
					width: '15%',
				},
			],
			columnsElements: [
				{
					title: '#',
					align: 'center',
					scopedSlots: { customRender: 'index' },
				},
				{
					title: 'Descripción',
					align: 'center',
					scopedSlots: { customRender: 'description' },
				},
				{
					title: 'Precio unitario',
					align: 'center',
					scopedSlots: { customRender: 'price' },
				},
				{
					title: 'Importe',
					align: 'center',
					scopedSlots: { customRender: 'importe' },
				},
				{
					title: 'Tiempo de entrega',
					align: 'center',
					scopedSlots: { customRender: 'delivery_time' },
				},
			],
			modalView: false,
			actualRecord: {},
			selectedRowKeys: [],
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
			},
		}
	},
	mounted() {
		this.initModule()
		if (this.branchOfficesList.length == 0) {
			this.$store.dispatch('branchOffices/GET')
		}
	},
	methods: {
		moment,
		numeral,
		getStatusBadge(status) {
			const statuses = {
				0: { text: 'Solicitud', color: 'orange' },
				1: { text: 'Cotizada', color: 'cyan' },
				5: { text: 'Enviada', color: 'geekblue' },
				2: { text: 'Autorizada', color: 'green' },
				3: { text: 'En sucursal', color: 'purple' },
				4: { text: 'Entregado', color: '#87d068' },
			}
			return statuses[status] || { text: 'Desconocido', color: 'default' }
		},
		getAmount(id) {
			let elements = utilities
				.objectValidate(
					this.impressmentListFiltered.find((e) => e.id == id),
					'impressmentElements',
					[],
				)
				.filter((e) => e.available)

			if (elements.length) {
				return numeral(elements.reduce((accumulator, item) => accumulator + item.price * item.quantity, 0)).format('$0,0.00')
			}

			return '---'
		},
		filterImpressments(branch_office_id) {
			if (branch_office_id == '') {
				this.impressmentListFiltered = _.cloneDeep(this.impressmentList)
			} else {
				this.impressmentListFiltered = this.impressmentList.filter((e) => e.branch_office_id == branch_office_id)
			}
			this.onSearch()
		},
		branchOffice(id) {
			return this.branchOfficesList.find((e) => e.id == id)
		},
		handleStatusChange(e) {
			this.searchText = ''
			this.impressmentListFiltered = []
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					status: e.target.value,
				},
			})
			this.initModule()
		},
		onAddRecord() {
			this.$router.push('/impressment/create')
		},
		initModule(pagination) {
			let payload = {
				status: this.searchText || this.odsText ? '' : this.filters.status,
				branch_office_id: this.branch_office_id,
				searchText: this.searchText,
				odsText: this.odsText,
				pagination: {
					perPage: this.pagination.pageSize,
					currentPage: utilities.objectValidate(pagination, 'current', this.pagination.current),
				},
			}

			this.$store.dispatch('impressment/GET', payload).then((reponse) => {
				this.impressmentListFiltered = _.cloneDeep(utilities.objectValidate(reponse, 'data', []))
				this.pagination = {
					current: utilities.objectValidate(reponse, 'pagination.currentPage', 1),
					pageSize: utilities.objectValidate(reponse, 'pagination.perPage', 10),
					total: utilities.objectValidate(reponse, 'pagination.total', 0),
				}
			})
		},
		onEditRecord(id) {
			this.$router.push(`/impressment/${id}`)
		},
		onDelete(id) {
			Swal.fire({
				title: 'Atención',
				text: 'La cotizaciíon será eliminada. ¿Deseas continuar?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then((result) => {
				//
				if (result.isConfirmed) {
					this.$store.dispatch('impressment/DELETE', { id })
				}
			})
		},
		downloadQuotation(id) {
			this.$store.dispatch('impressment/GENERATE_PDF', id).then((response) => {
				const base64Str = `data:application/pdf;base64,${response.data.base64}`
				this.actualPdfBase64 = base64Str
				this.actualPdfId = id
				this.quotationSrc = pdf.createLoadingTask(base64Str)
				this.quotationSrc.promise.then((pdfData) => {
					this.numPages = pdfData.numPages
					this.actualPage = 1
					this.modalQuotationView = true
				})
			})
		},
		closeQuotationModal() {
			this.modalQuotationView = false
			this.quotationSrc = null
			this.numPages = undefined
			this.actualPage = 1
			this.actualPdfBase64 = null
			this.actualPdfId = null
		},
		downloadPDF() {
			if (this.actualPdfBase64) {
				const link = document.createElement('a')
				link.href = this.actualPdfBase64
				link.download = `cotizacion_${this.actualPdfId}.pdf`
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		},
		sendQuotation(id) {
			let record = this.impressmentListFiltered.find((e) => e.id == id)
			let message = record && record.status == 5 ? '¿Estás seguro de enviar la cotización a la conversación?' : 'La cotización será cambiada de estatus a "ENVIADAS". ¿Deseas continuar?'
			Swal.fire({
				title: 'Atención',
				text: message,
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'Cancelar',
			}).then(async (result) => {
				if (result.isConfirmed) {
					let response = null
					if (record && record.status == 5) {
						response = await this.$store.dispatch('impressment/SEND_GENERATE_PDF', { id })
					} else {
						response = await this.$store.dispatch('impressment/UPDATE_STATUS', {
							id,
							status: 5, // Enviadas
						})
					}

					if (response && response.message) {
						Swal.fire({
							title: 'Atención',
							text: response.message,
							icon: response.success ? 'success' : 'error',
							confirmButtonText: 'Ok',
						})
					}
					this.initModule()
				}
			})
		},
		onCloseQuotation() {
			if (!this.selectedRowKeys.length) {
				Swal.fire({
					title: 'Atención',
					text: 'Debes seleccionar al menos un elemento de la cotización',
					icon: 'warning',
					showCancelButton: false,
				})

				return false
			}
			Swal.fire({
				title: 'Atención',
				text: '¿Deseas autorizar la cotización?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then(async (result) => {
				if (result.isConfirmed) {
					//
					let selectedRowKeys = []
					this.selectedRowKeys.forEach((index) => {
						selectedRowKeys.push(this.actualRecord.impressmentElements[index])
					})

					await this.$store.dispatch('impressment/UPDATE_STATUS', {
						id: this.actualRecord.id,
						status: 2, // Autorizadas
						selectedRowKeys,
					})

					this.modalView = false
					this.actualRecord = {}
					this.selectedRowKeys = []
				}
			})
		},
		returnToDraft(id) {
			Swal.fire({
				title: 'Atención',
				text: '¿Deseas regresar la cotización para editar?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store
						.dispatch('impressment/UPDATE_STATUS', {
							id,
							status: 0, // Borrador
						})
						.then(() => this.initModule())
				}
			})
		},
		completeQuotation(id) {
			Swal.fire({
				title: 'Atención',
				text: '¿Todos los productos de la cotización se encuentra en sucursal?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					//
					this.$store.dispatch('impressment/UPDATE_STATUS', {
						id,
						status: 3, // Autorizadas
					})
				}
			})
		},
		deliverQuotation(id) {
			Swal.fire({
				title: 'Atención',
				text: '¿Todos los productos de la cotización se han entregado?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					//
					this.$store.dispatch('impressment/UPDATE_STATUS', {
						id,
						status: 4, // Entregados
					})
				}
			})
		},
		onLinkPress(link) {
			window.open(link)
		},
		openModal(id) {
			this.actualRecord = _.cloneDeep(this.impressmentListFiltered.find((e) => e.id == id))
			let selectedRowKeys = []
			this.actualRecord.impressmentElements.forEach((e, index) => {
				if (e.confirmed) {
					selectedRowKeys.push(index)
				}
			})
			this.modalView = true
			this.selectedRowKeys = _.clone(selectedRowKeys)
		},
		closeModal() {
			this.modalView = false
		},
		onSelectChange(selectedRowKeys) {
			this.selectedRowKeys = selectedRowKeys
		},
		onSearch() {
			let searchValue = this.searchText
			const lowerCaseSearchValue = searchValue.toLowerCase()
			let localImpressments = _.cloneDeep(utilities.objectValidate(this.impressmentList, 'data', []))

			if (this.branch_office_id != '') {
				localImpressments = this.impressmentList.filter((e) => e.branch_office_id == this.branch_office_id)
			}

			this.impressmentListFiltered = localImpressments.filter(
				(item) =>
					item.impressmentElements.some((element) => element.description.toLowerCase().includes(lowerCaseSearchValue)) ||
					Object.values(item).some((val) => {
						if (val) {
							val = val.toString().toLowerCase()
							return val.includes(lowerCaseSearchValue)
						}
					}),
			)
		},
		allowOperations(elements) {
			return elements.filter((e) => e.available).length
		},
	},
}
</script>

<style lang="scss">
.tableImpressmentElements {
	td {
		padding-top: 5px !important;
		padding-bottom: 5px !important;
	}
}
</style>